export default __webpack_public_path__ + "static/media/logo.dabf53e3.png";